export { Modal, ModalBody, ModalFooter } from "./Modal";
export type { ModalProps, ModalSize, ModalVariant, ModalFooterProps } from "./Modal";
